// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_eY","gallery__header":"c-p_eZ","gallery__thumbs":"c-p_fa"};